module.exports = __webpack_public_path__ + "img/yandex.ad42ae05.svg";